<template>
  <div class="help">
    <div class="pageContent">
      <heading-wrap>
        <span slot="title">Admin Section</span>
      </heading-wrap>

      <div class="container-fluid site-content">
        <div class="row">
          <div class="col-md-12">
            <div class="panel  panel-default">
              <div class="panel-heading"></div>
              <div class="panel-body">
                <p>Go to Render Farm Manager</p>
                <p>Go to User Manager</p>
                <a href="#top">Back to top <i class="fa fa-arrow-circle-up" aria-hidden="true"></i></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeadingWrap from '@/components/HeadingWrap/heading-wrap'

export default {
  name: 'Help',
  components: {
    HeadingWrap
  },
  data: () => ({}),
  created () {
    document.body.classList.add('adminPage')
  },
  computed: {},
  methods: {},
  beforeRouteLeave (to, from, next) {
    document.body.classList.remove('adminPage')
    next()
  }
}
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/pages/admin.vue